import { titleUI } from 'platform/forms-system/src/js/web-component-patterns';
import { makeTitlePatterns } from 'platform/shared/health-apps/patterns/titles';
import React from 'react';
import content from '../locales/en/content.json';
import MedicarePageTitle from '../components/FormDescriptions/MedicarePageTitle';

export const DEFAULT_TITLE_OPTS = {
  applicant: { arrayBuilder: true },
  beneficiary: {
    other: content['noun--beneficiary'],
  },
  insurance: {
    arrayBuilder: true,
    dataKey: 'provider',
    fallback: content['noun--provider'],
  },
  sponsor: {
    matchRole: 'sponsor',
    other: content['noun--veteran'],
  },
};

export const {
  itemOrNounText,
  titleWithFormDataUI,
  titleWithNameUI,
  titleWithRoleUI,
} = makeTitlePatterns({
  defaultOther: content['noun--applicant'],
  defaultSelf: content['noun--your'],
  nameFormat: 'full',
});

/**
 * Creates a dynamic Medicare page title with participant name.
 * Uses a component that accesses Redux to get the full form data.
 * Generates titles like "Jane Doe's Medicare plan types"
 *
 * @param {string} title - The page-specific title (e.g., 'Medicare plan types')
 * @param {string|React.Component} [description=null] - Optional description
 * @returns {Object} UI schema object for titleUI
 */
export const medicarePageTitleUI = (title, description = null) =>
  titleUI({
    title: props => <MedicarePageTitle {...props} title={title} />,
    description,
    classNames:
      'vads-u-color--black vads-u-margin-top--0 mobile-lg:vads-u-font-size--h2 vads-u-font-size--h3 dd-privacy-mask',
  });

/**
 * Creates a subtitle UI for subsection headings.
 *
 * Uses h2 semantic level but styled as h3 for visual hierarchy.
 * Useful for creating subsections within a form page.
 *
 * @param {string} title - The subtitle text to display
 * @returns {Object} UI schema object for titleUI with subtitle styling
 *
 * @example
 * // Add a subsection title
 * uiSchema: {
 *   ...subtitleUI('Additional information'),
 *   fieldName: textUI('Field label')
 * }
 */
export const subtitleUI = title =>
  titleUI({
    title,
    headerLevel: 2,
    headerStyleLevel: 3,
  });
